import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MastersFilterContainer = _resolveComponent("MastersFilterContainer")!
  const _component_BachelorsFilterContainer = _resolveComponent("BachelorsFilterContainer")!
  const _component_ShortCoursesFilterContainer = _resolveComponent("ShortCoursesFilterContainer")!
  const _component_DistanceLearningFilterContainer = _resolveComponent("DistanceLearningFilterContainer")!
  const _component_PhdFilterContainer = _resolveComponent("PhdFilterContainer")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.portalType == _ctx.mastersValue)
      ? (_openBlock(), _createBlock(_component_MastersFilterContainer, { key: 0 }))
      : _createCommentVNode("v-if", true),
    (_ctx.portalType == _ctx.bachelorsValue)
      ? (_openBlock(), _createBlock(_component_BachelorsFilterContainer, { key: 1 }))
      : _createCommentVNode("v-if", true),
    (_ctx.portalType == _ctx.shortCoursesValue)
      ? (_openBlock(), _createBlock(_component_ShortCoursesFilterContainer, { key: 2 }))
      : _createCommentVNode("v-if", true),
    (_ctx.portalType == _ctx.distanceLearningValue)
      ? (_openBlock(), _createBlock(_component_DistanceLearningFilterContainer, { key: 3 }))
      : _createCommentVNode("v-if", true),
    (_ctx.portalType == _ctx.phdValue)
      ? (_openBlock(), _createBlock(_component_PhdFilterContainer, { key: 4 }))
      : _createCommentVNode("v-if", true)
  ]))
}